<template>
  <div>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="showCarrocerias" centered
      :title="$t('OS Preventivas Vencidas')">

      <b-table striped hover :items="arrayPlacas" :fields="fields" sticky-header="true">
        <template #cell(ACAO)="row">
          <div v-if="row.item.NR_SEQ_OS">
            <router-link :to="'os/' + row.item.NR_SEQ_OS" size="sm" class="mr-2 btn btn-success" style="padding: 0.25rem 0.5rem;
            font-size: 0.875rem;">
              {{ $t('Acessar OS') }}
            </router-link>
          </div>
          <div v-if="!row.item.NR_SEQ_OS">
            <b-button @click="gerarOs(row.item)" size="sm" class="mr-2">
              {{ $t('Gerar OS') }}
            </b-button>
          </div>
        </template>
      </b-table>

      <template #modal-footer>
        <div class="w-100">
          <div class="row center" style="justify-content: center; ">
            <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalCarrocerias')">
              {{ $t('Fechar') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>

export default {
  name: 'ModalItems',
  props: {
    tipoPreventiva: {}
  },
  data() {
    return {
      selectServico: '',
      obsExterna: '',
      showCarrocerias: true,
      idConjunto: '',
      countPecas: 1,
      disabledPeca: true,
      // fields: [ 
      //   { key: 'ACAO', label: this.$t('Ação') },
      //   { key: 'PLACA', label: this.$t('Placa') },
      //   { key: 'PROXIMO_CICLO', label: this.$t('Próximo Ciclo') },
      //   { key: 'VENCIMENTO', label: this.$t('Vencimento') }
      // ],
      arrayPlacas: []      
    }
  },
  methods: {
    gerarOs(value) {
      const cdClifor = this.$store.getters['filial/filial']

      const execucao = {
        placa: value.PLACA,
        cdProxCiclo: value.CD_PROX_CICLO,
        cdClifor: cdClifor.tecnicoId,
        cd_prox_ordem_carroceria: value.CD_PROX_ORDEM_CARROCERIA
      }

      this.$store.dispatch('osItem/gerarPreventivaCarroceria', { data: execucao }).then(response => {
        this.$emit('showModalVencidas')
        this.$emit('refresh')
        this.$swal.fire({
          title: this.$t('Sucesso'),
          text: this.$t('Ordem gerada com sucesso'),
          icon: 'success'
        })
      })

    },

    getPlacas() {
      const data = {
        tipoPreventiva: this.tipoPreventiva,
        stPreventiva: this.stPreventiva
      }

      this.$store.dispatch('osItem/carroceriasPreventivas', { stPreventivaCarroceria: this.tipoPreventiva }).then(response => {
        let arrayPlaca = response.data

        arrayPlaca.forEach(placa => {
          const ano = placa.DATA.substring(0, 4)
          const mes = placa.DATA.substring(5, 7)
          const dia = placa.DATA.substring(8, 10)

          const fullData = `${dia}/${mes}/${ano}`

          this.arrayPlacas.push(
            {
              'PLACA': placa.PLACA,
              'PROXIMO_CICLO': placa.PROX_CICLO,
              'VENCIMENTO': fullData,
              'PROXIMO_KM': 0,
              'KM_ATUAL': parseInt(placa.KM_ATUAL).toLocaleString('pt-BR', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }),
              'CD_PROX_CICLO': placa.CD_PROX_CICLO,
              'CD_PROX_ORDEM_CARROCERIA': placa.CD_PROX_ORDEM_CARROCERIA,
              'NR_SEQ_OS': placa.NR_SEQ_OS
            },
          )
        });
      }).catch(error => {
        console.log(error)
      })
    }
  },
  computed: {
    fields() {
      return [
        { key: 'ACAO', label: this.$t('Ação') },
        { key: 'PLACA', label: this.$t('Placa') },
        { key: 'PROXIMO_CICLO', label: this.$t('PROXIMO_CICLO') },
        { key: 'VENCIMENTO', label: this.$t('VENCIMENTO') }
      ]
    },  
    placas() {
      const placas = this.$store.getters['osItem/carroceriasPreventivas']

      if (!placas) {
        this.$store.dispatch('osItem/carroceriasPreventivas')

        return []
      }

      return [placas]
    },
    items() {
      return this.$store.getters['osItem/items']
    },
  },

  created() {
    this.getPlacas()
    console.log(this.tipoPreventiva)
  },
}
</script>
<style scoped>
#modalItems {
  pointer-events: none !important;
  height: 750px !important;
}

.close {
  display: none !important;
}

#totalPecas {
  height: 340px !important;
  overflow-x: auto !important;
}

.modal-content {
  height: 700px !important;
}

.divGerar {
  border: 1px solid #c1c1c1;
}
</style>